// Icônes : sprite SVG Phosphor (assets/icons.svg, engendré par scripts/icones.mjs), trait 1,5 px, une seule famille.
// ico('house') → <svg class="ico"><use href="assets/icons.svg#house"/></svg>, toujours aria-hidden : le sens est
// porté par le texte ou l'aria-label du bouton, jamais par le glyphe.
import { brut } from '../core/html.js';
var VERSION = typeof __ICONES_V__ !== 'undefined' ? __ICONES_V__ : '0';
export function ico(nom, opts) {
    opts = opts || {};
    var t = opts.taille || 20;
    return brut('<svg class="ico' + (opts.classe ? ' ' + opts.classe : '') + '" width="' + t + '" height="' + t + '" aria-hidden="true" focusable="false"><use href="assets/icons.svg?v=' + VERSION + '#' + nom + '"></use></svg>');
}
window.ico = ico;
